import { forwardRef } from "react";
import { sideImage } from "helper/images";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { logo } from "helper/images";

const AuthLayout = forwardRef((props, ref) => {
  const {
    children,
    apiData = {
      title: "",
      desc: "",
      type: "pending",
    },
    onCloseModal = () => {},
  } = props;

  return (
    <div className="App h-[100vh] flex justify-center">
      <div className="flex row justify-around items-center">
        <div className="hidden xl:flex h-screen items-center">
          <img
            className="mx-[58px]"
            height={622}
            width={605}
            src={sideImage}
            alt=""
          />
        </div>
        <div className="shadow-100 border rounded-md bg-white py-10 md:w-[550px] flex flex-col items-center p-4">
          <img
            src={logo}
            alt=""
            className="w-40 lg:w-44 mt-8 lg:mt-0 md:mt-0"
          />
          {children}
        </div>
      </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        actionButton={apiData.actionButton}
        ref={ref}
        onCloseModal={onCloseModal}
      />
    </div>
  );
});

export default AuthLayout;
